import { MultiSelect, type FieldSettingsModel, type MultiSelectChangeEvent } from "@syncfusion/react-dropdowns";
import {  useEffect, useState, type ReactNode } from "react";
import type { DataSource } from "../../services/data-source";

export interface ApiMultiSelectOptions<T extends {id:string}> {
    dataSource: DataSource<T>
    children?: ReactNode
    placeHolder: string,
    fields: FieldSettingsModel,
    value: T[],
    onChange?: (value:T[]) => void
}
export function ApiMultiSelect<T extends {id:string}>(opts: ApiMultiSelectOptions<T>){

    let [val, setVal] = useState<string[]>([]);

    const ds = opts.dataSource;

    useEffect(()=>{setVal((opts.value ||[]).map(item => item.id))}, []);

    const handleChange = (event: MultiSelectChangeEvent) => {

     let value = (event.value as string[]).map(id => opts.dataSource.data.find(item => item.id == id)).filter(item => !!item);
     setVal(event.value as string[]);
     opts.onChange!(value);
    };

    

    return (
    <MultiSelect 
    placeholder={opts.placeHolder} 
    dataSource={ds.data} 
    readOnly={!opts.onChange}
    fields={opts.fields} 
    allowObjectBinding={true}
    onChange={handleChange}
    value={val}>

    </MultiSelect>)
}